<template>
  <div>
    <b-modal
      id="modal-export-file"
      size="md"
      ref="modalExportFile"
      title="Экспорт файла"
      :ok-only="false"
      :no-fade="true"
      @ok="okHandler"
      @cancel="cancelHandler"
      @close="cancelHandler"
      @hide="cancelHandler"
      button-size="sm"
      ok-title="Экспортировать"
      cancel-title="Отменить"
    >
      <b-form-checkbox
        id="checkbox-stamp"
        class="mb-3"
        v-model="hasStamp"
        name="checkbox-stamp"
        switch
        size="md"
      >
        Подпись и печать
      </b-form-checkbox>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ExportFile",
  data() {
    return {
      hasStamp: true,
      callback: null
    }
  },
  methods: {
    show(callback) {
      this.callback = callback;
      this.$refs.modalExportFile.show();
    },
    hide() {
      this.$refs.modalExportFile.hide();
      this.hasStamp = true;
    },
    okHandler() {
      if (this.callback !== null) {
        this.callback(this.hasStamp);
      }

      this.hide();
    },
    cancelHandler() {
      this.hasStamp = true;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/ExportFile.vue